<app-industry-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [parentFormGroup]="form"
  class="kendo-select-filter"
  [isInModal]="false"
>
</app-industry-select>
